import { ConnectionAuthInfo } from '../types/IConnectionAuthInfo';
import { UnencryptedConnectionKeychain } from '../types/IConnectionKeyChain';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface RevertFlowParams {
  id: string;
  version: number;
  keychains?: UnencryptedConnectionKeychain[];
  encryptedPasswordKeyId?: string;
}

export interface RevertFlowResult extends IResult {
  failedConnection?: ConnectionAuthInfo;
}

export class RevertFlowRequest extends Request<RevertFlowParams, RevertFlowResult> {
  constructor(params: RevertFlowParams) {
    super('revertFlow', params);
  }
}
